var React = require('react');

function AssignUser (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(2 2)"},[React.createElement("circle",{"cx":"6","cy":"3","r":"3","stroke":"currentColor","strokeWidth":"2.5","key":0}),React.createElement("path",{"stroke":"currentColor","strokeWidth":"2.5","d":"M12 13c0-3.513-2.686-6-6-6s-6 2.534-6 6c0 1.011 12 1.043 12 0z","key":1}),React.createElement("rect",{"width":"2","height":"8","x":"16","y":"3","fill":"currentColor","rx":"1","transform":"rotate(90 17 7)","key":2}),React.createElement("rect",{"width":"2","height":"8","x":"16","y":"3","fill":"currentColor","rx":"1","transform":"rotate(-180 17 7)","key":3})]));
}

AssignUser.defaultProps = {"width":"23","height":"18","viewBox":"0 0 23 18"};

module.exports = AssignUser;

AssignUser.default = AssignUser;
